import { ActionTypes } from '../actions/action-types';

const initialState: any = {cv: {}};

export default (state: any = initialState, action: any) => {
  switch (action.type) {
    case ActionTypes.DATA_LOADED:
      return {...state, ...action.payload};

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/cv.reducer.ts